// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5967af42","239":"53b9c7ef","455":"2d6b40ee"}[chunkId] + ".chunk.js";
};